import { FilterProps } from "@made-people/blueprint-filter";
import { Cross } from "../../../assets/icons/Cross";

export const Filter: FilterProps = {
  template: "glasgow",
  drawerSettings: {
    header: {
      closeIcon: <Cross className="w-3 h-3" />,
    },
  },
  activeFilters: {
    enabled: true,
    heading: {
      variants: {
        headingSize: "xs",
      },
    },
    buttonVariants: {
      color: "grey",
      style: "solid",
      size: "sm",
      rounded: "full",
    },
  },
  applyButtonVariants: {
    color: "primary",
    style: "solid",
    size: "md",
  },
  accordion: {
    layout: {
      spacing: {
        applySpacing: "false",
      },
    },
    variants: {
      context: "filter",
    },
  },
};
